<div class="growerProgramImportDialog">

    <div class="row dialogHeader padding-l20">
        <h2>Import Budgeted Spends</h2>
    </div>
    <div class="row padding-t10 padding-b10 padding-l20" style="max-width: 100%">
        <div class="col-md-2 padding-r0">
            <input type="file" class="custom-file-input" id="importFile" #uploader hidden
                   accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                   (click)="$event.target.value=null"
                   (change)="onFileSelect($event)">
            <button mat-raised-button class="btns w140" color="primary" (click)="uploader.click()">Import</button>
        </div>
        <div class="col-md-4">
        </div>
    </div>

    <div class="row">
        <div class="col-12 margin-t10">
            <div class="productTableOuter">
                <div class="tableContainer prodTableContainer">
                    <table mat-table [dataSource]="importDataSource" multiTemplateDataRows class="matTables productTable">
                        <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                            <div *ngIf="column=='errorMessage'"><th mat-header-cell *matHeaderCellDef>Error Message</th>
                </div>
                <div *ngIf="column=='budgetName'"><th mat-header-cell *matHeaderCellDef>Budget Name</th></div>
                <div *ngIf="column=='retailerName'"><th mat-header-cell *matHeaderCellDef>Retailer</th></div>
                <div *ngIf="column=='estimatedQuantity'"><th mat-header-cell *matHeaderCellDef>Estimated<div>Quantity</div> </th></div>
                <div *ngIf="column=='estimatedSpend'"><th mat-header-cell *matHeaderCellDef>Estimated Spend <div>Amount($)</div></th></div>
                <div *ngIf="column=='grower'"><th mat-header-cell *matHeaderCellDef>Grower</th></div>
                <div *ngIf="column=='seller'"><th mat-header-cell *matHeaderCellDef>Seller</th></div>
                <div *ngIf="column=='programName'"><th mat-header-cell *matHeaderCellDef>Program Name</th></div>
                <div *ngIf="column=='salesChannel'"><th mat-header-cell *matHeaderCellDef>Sales Channel</th></div>
                <div *ngIf="column=='marketingBrand'"><th mat-header-cell *matHeaderCellDef>Marketing Brand</th></div>
                <div *ngIf="column=='productLine'"><th mat-header-cell *matHeaderCellDef>Product Line</th></div>

                <td mat-cell *matCellDef="let element; let i = dataIndex">
                    <div *ngIf="column=='errorMessage' && element.newErrors.length > 0 " class="text-left row inline-row-error">
                        <div *ngFor="let err of element.newErrors">
                            <span> {{err.message}}</span>
                        </div>
                    </div>
                    <div *ngIf="column=='errorMessage' && element.newWarnings.length > 0 " class="text-left row inline-row-warning">
                        <div *ngFor="let err of element.newWarnings">
                            <span> {{err.message}}</span>
                        </div>
                    </div>
                    <div *ngIf="column=='budgetName'" class="text-left">
                        <p> {{element.budgetName}} </p>
                    </div>

                    <div *ngIf="column=='retailerName'" class="text-left">
                        <p> {{element.retailerAccountName != null && element.retailerAccountName != '' ? element.retailerAccountName : element.retailerAccountNumberString}} </p>
                    </div>

                    <div *ngIf="column=='estimatedQuantity'" class="text-center">
                        <p> {{element.estimatedQuantity != null  ? element.estimatedQuantity : element.estimatedQuantityString}} </p>
                    </div>
                    <div *ngIf="column=='estimatedSpend'" class="text-center">
                        <p> {{element.estimatedAmountToPay != null ? element.estimatedAmountToPay : element.estimatedAmountToPayString}} </p>
                    </div>

                    <div *ngIf="column=='grower'" class="text-left">
                        <p> {{element.growerName != null && element.growerName != '' ? element.growerName : element.growerNumberString}}</p>
                    </div>

                    <div *ngIf="column=='programName'" class="text-left">
                        <p> {{element.programName}} </p>
                    </div>

                    <div *ngIf="column=='seller'" class="text-left">
                        <p> {{element.sellerName != null &&  element.sellerName != '' ? element.sellerName : element.sellerAccountNumberString}}</p>
                    </div>

                    <div *ngIf="column=='salesChannel'" class="text-center">
                        <p> {{element.productSegmentDesc}} </p>
                    </div>
                    <div *ngIf="column=='marketingBrand'" class="text-center">
                        <p> {{element.marketingBrandDesc}} </p>
                    </div>
                    <div *ngIf="column=='productLine'" class="text-center">
                        <p> {{element.productLineDesc}} </p>
                    </div>
                </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;" class="d-none d-md-table-row"></tr>
                <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                    class="example-element-row"></tr>
                </table>
            </div>
        </div>
    </div>
    <div class="col-12 popupFooter">
        <div class="row">
            <div class="col-2">
                <button mat-raised-button class="btns wide100" color="primary" (click)="onClose()">Cancel</button>
            </div>
            <div class="col-2">
                <button mat-raised-button class="btns wide100" color="primary" [disabled]="isSaveButtonDisabled" (click)="onSave()">Save Spend</button>
            </div>
        </div>
    </div>
</div>
